import React, { useEffect, useState } from "react";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import "./index.css";
import "./target.css";
import "moment/locale/pt-br";
import { CurrencyInput } from "./styles";
import { Tooltip } from '@material-ui/core'

import CurrencyTextField from "@unicef/material-ui-currency-textfield/dist/CurrencyTextField";

const formatter = new Intl.NumberFormat("pt-BR", {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});
const formatterPercent = new Intl.NumberFormat("pt-BR", {
	style: "percent",
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

const MoneyTableInput = (props) => {
	const { keyIndex, allowChange, item, type, index, values } = props;

	const handleFocus = (e) => {
		setTimeout(() => {
			e.target.select();
		}, 100);
	};

	return (
		<CurrencyInput
			className={item.ancora.replace(" ", "") + type}
			autoFocus={false}
			onFocus={handleFocus}
			currencySymbol=""
			placeholder=""
			decimalCharacter=","
			minimumValue="0"
			style={{
				padding: "3px 5px",
				border: "1px solid #767676",
				height: "15px",
				backgroundColor: "#ffffff",
				borderRadius: 2,
			}}
			modifyValueOnWheel={false}
			digitGroupSeparator="."
			value={Number(values[index] || 0)}
			onChange={(event, value) => {
				values[index] = value;
			}}
			disabled={allowChange}
      id={keyIndex}
		/>
	);
};

function TableContent({
	tableData,
	headerData,
	totalTableData,
	mediaCrescimento,
	updateMeta,
	setUpdateMetaData,
	setUpdateMeta,
	hideColumns,
	allowChange,
}) {
	const [volumesValores, setVolumesValores] = useState([]);
	const [receitaValores, setReceitaValores] = useState([]);
	const [header, setHeader] = useState({
		mes1Nome: "",
		mes2Nome: "",
		mes3Nome: "",
		mesMetaNome: "",
		dataHora: "",
		mediaCrescimento: "",
	});
	const toCurrency = (e) => {
		return (
			<>
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<span></span>
					<span>{e ? formatter.format(e) : "0,00"}</span>
				</div>
			</>
		);
	};

	useEffect(() => {
		document.addEventListener("keydown", function (event) {
			if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
				try {
          let typeInput = 'class'

					let index = Number(
						event.target.attributes.class.value.replace("focus-visible", "")
					);

          if(!index) {
            index = Number(event.target.attributes.id.value);
            typeInput = 'id'
          }

					if (index) {
            let actual;
            if(typeInput == 'class') {
              actual = document.getElementsByClassName(index.toString())[0];
            } else {
              actual = document.getElementById(index.toString());
            }
						document
							.getElementById(actual.id)
							.classList.remove("focus-visible");

						const next = Number(index) + 1;
						let element = document.getElementsByClassName(next.toString())[0];

            if(!element?.id) {
              element = document.getElementById(next.toString())
            }

						document.getElementById(element.id).focus();
						document.getElementById(element.id).classList.add("focus-visible");
						document.getElementById(element.id).select();
					}
				} catch (error) {}

				event.preventDefault();
			}
		});

		if (headerData) {
			setHeader({
				mes1Nome: headerData.mes1Nome,
				mes2Nome: headerData.mes2Nome,
				mes3Nome: headerData.mes3Nome,
				mesMetaNome: headerData.mesMetaNome,
				dataHora: headerData.hoje,
				mediaCrescimento: headerData.mediaCrescimento,
			});
		}
	}, [headerData]);

	// useEffect(() => {
	//   if (tableData) {
	//     setModel({
	//       ancora: tableData[0].ancora,
	//       metaMesMetaVolumeObjetivo: tableData[0].metaMesMetaVolumeObjetivo,
	//       metaMesMetaReceitaObjetivo: tableData[0].metaMesMetaReceitaObjetivo,
	//       metaMesMetaQuantidadeOperacoesObjetivo: tableData[0].metaMesMetaQuantidadeOperacoesObjetivo,
	//       metaMesMetaQuantidadeQualificadosObjetivo:
	//         tableData[0].metaMesMetaQuantidadeQualificadosObjetivo,
	//     });
	//   }
	// }, [tableData]);

	useEffect(() => {
		let valoresVolume = [];
		let valoresReceita = [];
		if (tableData) {
			tableData.forEach((ancora) => {
				valoresVolume.push(
					ancora.metaMesMetaVolumeObjetivo > 0
						? ancora.metaMesMetaVolumeObjetivo
						: 0.0
				);
				valoresReceita.push(
					ancora.metaMesMetaReceitaObjetivo
						? ancora.metaMesMetaReceitaObjetivo
						: 0.0
				);
			});

			setVolumesValores(valoresVolume);
			setReceitaValores(valoresReceita);
		}
	}, [tableData]);

	useEffect(() => {
		const metas = [];
		if (tableData) {
			tableData.forEach((ancora) => {
				metas.push({
					ancoraId: ancora.metaMesMetaAncoraId,
					ancoraMetaId: ancora.metaMesMetaAncoraMetaId,
					ano: ancora.metaMesMetaAno,
					liberadoCar: ancora.metaMesLiberadoCar,
					mes: ancora.metaMesMetaMes,
					status: ancora.metaMesMetaStatus,
					dataAtualizacao: ancora.metaMesMetaDataAtualizacao,
					volumeObjetivo: parseFloat(
						document.querySelector(
							"." + ancora.ancora.replace(" ", "") + "Volume"
						)
							? document
									.querySelector(
										"." + ancora.ancora.replace(" ", "") + "Volume"
									)
									.querySelector("input")
									?.value.replace(/\./g, "")
									.replace(",", ".")
							: 0
					),
					volumeRealizado: ancora.metaMesMetaVolumeRealizado,
					receitaObjetivo: parseFloat(
						document.querySelector(
							"." + ancora.ancora.replace(" ", "") + "Receita"
						)
							? document
									.querySelector(
										"." + ancora.ancora.replace(" ", "") + "Receita"
									)
									.querySelector("input")
									.value.replace(/\./g, "")
									.replace(",", ".")
							: 0
					),
					receitaRealizado: ancora.metaMesMetaReceitaRealizado,
					quantidadeOperacoesObjetivo: parseInt(
						document.getElementById(
							ancora.ancora.replace(" ", "") + "QuantidadeOperacoes"
						)?.value
					),
					quantidadeOperacoesRealizado:
						ancora.metaMesMetaQuantidadeOperacoesRealizado,
					quantidadeQualificadosObjetivo: parseInt(
						document.getElementById(
							ancora.ancora.replace(" ", "") + "QuantidadeQualificados"
						)?.value
					),
					quantidadeQualificadosRealizado:
						ancora.metaMesMetaQuantidadeQualificadosRealizado,
					quantidadeNaoQualificadosObjetivo: parseInt(
						document.getElementById(
							ancora.ancora.replace(" ", "") + "QuantidadeNaoQualificados"
						)?.value
					),
					quantidadeNaoQualificadosRealizado:
						ancora.metaMesMetaQuantidadeNaoQualificadosRealizado,
				});
			});
		}
		if (updateMeta) {
			setUpdateMeta(false);
			if (metas) {
				setUpdateMetaData(metas);
			}
		}
	}, [updateMeta]);

	const updateValues = (item) => {
		try {
      if (
				document.querySelector("." + item.ancora.replace(" ", "") + "Volume")
			) {
				document
					.querySelector("." + item.ancora.replace(" ", "") + "Volume")
					.querySelector("input").value = formatter.format(
					item.metaMesMetaVolumeObjetivo
				);
			}			
		} catch (error) {
			document
				.querySelector("." + item.ancora.replace(" ", "") + "Volume")
				.querySelector("input")
				.value?.setAttribute("value", formatter.format(item.metaMesMetaVolumeObjetivo));
		}

		try {
      if (
				document.querySelector("." + item.ancora.replace(" ", "") + "Receita")
			) {
				document
					.querySelector("." + item.ancora.replace(" ", "") + "Receita")
					.querySelector("input").value = formatter.format(
					item.metaMesMetaReceitaObjetivo
				);
			}
		} catch (error) {
			document
				.querySelector("." + item.ancora.replace(" ", "") + "Receita")
				.querySelector("input")
				.value?.setAttribute("value", formatter.format(item.metaMesMetaReceitaObjetivo));
		}

		try {
			document.getElementById(
				item.ancora.replace(" ", "") + "QuantidadeOperacoes"
			).value = item.metaMesMetaQuantidadeOperacoesObjetivo;
		} catch (error) {
			document
				.getElementById(item.ancora.replace(" ", "") + "QuantidadeOperacoes")
				?.setAttribute("value", item.metaMesMetaQuantidadeOperacoesObjetivo);
		}

		try {
			document.getElementById(
				item.ancora.replace(" ", "") + "QuantidadeQualificados"
			).value = item.metaMesMetaQuantidadeQualificadosObjetivo;
		} catch (error) {
			document
				.getElementById(item.ancora.replace(" ", "") + "QuantidadeQualificados")
				?.setAttribute("value", item.metaMesMetaQuantidadeQualificadosObjetivo);
		}

		try {
			document.getElementById(
				item.ancora.replace(" ", "") + "QuantidadeNaoQualificados"
			).value = item.metaMesMetaQuantidadeNaoQualificadosObjetivo;
		} catch (error) {
			document
				.getElementById(item.ancora.replace(" ", "") + "QuantidadeNaoQualificados")
				?.setAttribute("value", item.metaMesMetaQuantidadeNaoQualificadosObjetivo);
		}
	};

	let keyIndex = -4;

	const bodyTable = tableData?.map(function (item, index) {
		setTimeout(() => {
			updateValues(item);
		}, 600);

		keyIndex += 4;

		const bgColor = index % 2 === 0 ? '#EEEEEE' : "white";

		return (
			// eslint-disable-next-line react/jsx-key
			// eslint-disable-next-line react/jsx-no-comment-textnodes
			<>
				<TableRow className={"primeira-linha"} style={{ backgroundColor: bgColor }}>
					<Tooltip placement="top" title={
						item.analistas ? 
						<div dangerouslySetInnerHTML={{__html: item.analistas}}></div> : ''}
					>
						<TableCell rowSpan={5} align="left">
							<span style={{ marginLeft: "10px" }}>{item.ancora}</span>
						</TableCell>
					</Tooltip>
					<TableCell align="left">Volume</TableCell>
					{!hideColumns && (
						<TableCell align="right">{toCurrency(item.mes3Volume)}</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">{toCurrency(item.mes2Volume)}</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">{toCurrency(item.mes1Volume)}</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{toCurrency(item.mediaTrimestreVolume)}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{toCurrency(item.mediaCrescimentoVolume)}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{toCurrency(item.metaMesAnteriorVolume)}
						</TableCell>
					)}
					<TableCell>
						<MoneyTableInput
							keyIndex={keyIndex + 1}
							allowChange={allowChange}
							item={item}
							type={"Volume"}
							index={index}
							values={volumesValores}
						/>
					</TableCell>
					<TableCell align="right">
						{toCurrency(item.situacaoAtualVolume)}
					</TableCell>
					<TableCell
						style={{
							color: item.percentualAtingidoVolume < 0 ? "red" : "blue",
						}}
						align="right"
					>
						{formatterPercent.format(item.percentualAtingidoVolume / 100)}
					</TableCell>
					<TableCell align="right">
						{formatterPercent.format(item.percentualPonderadoVolume / 100)}
					</TableCell>
					<TableCell rowSpan={5} align="right">
						<span style={{ marginRight: "10px" }}>
							{formatterPercent.format(item.percentualPonderadoTotal / 100)}
						</span>
					</TableCell>
				</TableRow>
				<TableRow style={{ backgroundColor: bgColor }}>
					<TableCell align="left">Receita</TableCell>
					{!hideColumns && (
						<TableCell align="right">{toCurrency(item.mes3Receita)}</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">{toCurrency(item.mes2Receita)}</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">{toCurrency(item.mes1Receita)}</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{toCurrency(item.mediaTrimestreReceita)}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{toCurrency(item.mediaCrescimentoReceita)}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{toCurrency(item.metaMesAnteriorReceita)}
						</TableCell>
					)}
					<TableCell>
						<MoneyTableInput
							keyIndex={keyIndex +2}
							allowChange={allowChange}
							item={item}
							type={"Receita"}
							index={index}
							values={receitaValores}
						/>
					</TableCell>
					<TableCell align="right">
						{toCurrency(item.situacaoAtualReceita)}
					</TableCell>
					<TableCell
						style={{
							color: item.percentualAtingidoReceita < 0 ? "red" : "blue",
						}}
						align="right"
					>
						{formatterPercent.format(item.percentualAtingidoReceita / 100)}
					</TableCell>
					<TableCell align="right">
						{formatterPercent.format(item.percentualPonderadoReceita / 100)}
					</TableCell>
				</TableRow>
				<TableRow style={{ backgroundColor: bgColor }}>
					<TableCell align="left">Qtd. Qualificados</TableCell>
					{!hideColumns && (
						<TableCell align="right">
							{item.mes3QuantidadeQualificados}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{item.mes2QuantidadeQualificados}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{item.mes1QuantidadeQualificados}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{item.mediaTrimestreQuantidadeQualificados}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{item.mediaCrescimentoQuantidadeQualificados}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{item.metaMesAnteriorQuantidadeQualificados}
						</TableCell>
					)}
					<TableCell>
						<input
							className={keyIndex + 4}
							disabled={allowChange}
							style={{ padding: "1px 5px" }}
							autoComplete="off"
							onChange={(event) => {
								let valueFormated = event.target.value.replace(/[^0-9]/g, "");
								event.target.value = valueFormated;
							}}
							id={item.ancora.replace(" ", "") + "QuantidadeQualificados"}
						></input>
					</TableCell>
					<TableCell align="right" style={{ borderLeft: "1px solid white" }}>
						{item.situacaoAtualQuantidadeQualificados}
					</TableCell>
					<TableCell
						style={{
							color:
								item.percentualAtingidoQuantidadeQualificados < 0
									? "red"
									: "blue",
							borderLeft: "1px solid white",
						}}
						align="right"
					>
						{formatterPercent.format(
							item.percentualAtingidoQuantidadeQualificados / 100
						)}
					</TableCell>
					<TableCell align="right">
						{formatterPercent.format(
							item.percentualPonderadoQuantidadeQualificados / 100
						)}
					</TableCell>
				</TableRow>
				<TableRow style={{ backgroundColor: bgColor }}>
					<TableCell align="left">Qtd. Não Qualificados</TableCell>
					{!hideColumns && (
						<TableCell align="right">
							{item.mes3QuantidadeNaoQualificados}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{item.mes2QuantidadeNaoQualificados}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{item.mes1QuantidadeNaoQualificados}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{item.mediaTrimestreQuantidadeNaoQualificados}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{item.mediaCrescimentoQuantidadeNaoQualificados}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{item.metaMesAnteriorQuantidadeNaoQualificados}
						</TableCell>
					)}
					<TableCell>
						<input
							className={keyIndex + 4}
							disabled={allowChange}
							style={{ padding: "1px 5px" }}
							autoComplete="off"
							onChange={(event) => {
								let valueFormated = event.target.value.replace(/[^0-9]/g, "");
								event.target.value = valueFormated;
							}}
							id={item.ancora.replace(" ", "") + "QuantidadeNaoQualificados"}
						></input>
					</TableCell>
					<TableCell align="right" style={{ borderLeft: "1px solid white" }}>
						{item.situacaoAtualQuantidadeNaoQualificados}
					</TableCell>
					<TableCell
						style={{
							color:
								item.percentualAtingidoQuantidadeNaoQualificados < 0
									? "red"
									: "blue",
							borderLeft: "1px solid white",
						}}
						align="right"
					>
						{formatterPercent.format(
							item.percentualAtingidoQuantidadeNaoQualificados / 100
						)}
					</TableCell>
					<TableCell align="right">
						{formatterPercent.format(
							item.percentualPonderadoQuantidadeNaoQualificados / 100
						)}
					</TableCell>
				</TableRow>
				<TableRow style={{ backgroundColor: bgColor }}>
					<TableCell align="left">Qtd. Operações</TableCell>
					{!hideColumns && (
						<TableCell align="right">{item.mes3QuantidadeOperacoes}</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">{item.mes2QuantidadeOperacoes}</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">{item.mes1QuantidadeOperacoes}</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{item.mediaTrimestreQuantidadeOperacoes}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{item.mediaCrescimentoQuantidadeOperacoes}
						</TableCell>
					)}
					{!hideColumns && (
						<TableCell align="right">
							{item.metaMesAnteriorQuantidadeOperacoes}
						</TableCell>
					)}
					<TableCell>
						<input
							className={keyIndex + 3}
							disabled={allowChange}
							style={{ padding: "1px 5px" }}
							autoComplete="off"
							onChange={(event) => {
								let valueFormated = event.target.value.replace(/[^0-9]/g, "");
								event.target.value = valueFormated;
							}}
							id={item.ancora.replace(" ", "") + "QuantidadeOperacoes"}
						></input>
					</TableCell>
					<TableCell align="right" style={{ borderLeft: "1px solid white" }}>
						{item.situacaoAtualQuantidadeOperacoes}
					</TableCell>
					<TableCell
						style={{
							color:
								item.percentualAtingidoQuantidadeOperacoes < 0 ? "red" : "blue",
							borderLeft: "1px solid white",
						}}
						align="right"
					>
						{formatterPercent.format(
							item.percentualAtingidoQuantidadeOperacoes / 100
						)}
					</TableCell>
					<TableCell align="right">
						{formatterPercent.format(
							item.percentualPonderadoQuantidadeOperacoes / 100
						)}
					</TableCell>
				</TableRow>
			</>
		);
	});

	const totalTable = (
		// eslint-disable-next-line react/jsx-key
		// eslint-disable-next-line react/jsx-no-comment-textnodes
		<>
			<TableRow
				className="linha-cinza primeira-linha"
				style={{ border: "2px solid gray", borderBottom: "0px solid white" }}
			>
				<TableCell rowSpan={5} align="left">
					<span style={{ marginLeft: "10px" }}>TOTAL</span>
				</TableCell>
				<TableCell align="left">Volume</TableCell>
				{!hideColumns && (
					<TableCell align="right">
						{toCurrency(headerData?.totalizador?.mes3Volume)}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{toCurrency(headerData?.totalizador?.mes2Volume)}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{toCurrency(headerData?.totalizador?.mes1Volume)}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{toCurrency(headerData?.totalizador?.mediaTrimestreVolume)}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{toCurrency(headerData?.totalizador?.mediaCrescimentoVolume)}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{toCurrency(headerData?.totalizador?.metaMesAnteriorVolume)}
					</TableCell>
				)}
				<TableCell align="right">
					{toCurrency(headerData?.totalizador?.metaMesMetaVolume)}
				</TableCell>
				<TableCell align="right">
					{toCurrency(headerData?.totalizador?.situacaoAtualVolume)}
				</TableCell>
				<TableCell
					style={{
						color:
							headerData?.totalizador?.percentualAtingidoVolume < 0
								? "red"
								: "blue",
					}}
					align="right"
				>
					{formatterPercent.format(
						headerData?.totalizador?.percentualAtingidoVolume / 100
					)}
				</TableCell>
				<TableCell align="right">
					{formatterPercent.format(
						headerData?.totalizador?.percentualPonderadoVolume / 100
					)}
				</TableCell>
				<TableCell rowSpan={5} align="right">
					<span style={{ marginRight: "10px" }}>
						{formatterPercent.format(
							headerData?.totalizador?.percentualPonderadoTotal / 100
						)}
					</span>
				</TableCell>
			</TableRow>
			<TableRow
				className="linha-cinza"
				style={{ borderRight: "2px solid gray", borderLeft: "2px solid gray" }}
			>
				<TableCell align="left">Receita</TableCell>
				{!hideColumns && (
					<TableCell align="right">
						{toCurrency(headerData?.totalizador?.mes3Receita)}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{toCurrency(headerData?.totalizador?.mes2Receita)}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{toCurrency(headerData?.totalizador?.mes1Receita)}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{toCurrency(headerData?.totalizador?.mediaTrimestreReceita)}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{toCurrency(headerData?.totalizador?.mediaCrescimentoReceita)}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{toCurrency(headerData?.totalizador?.metaMesAnteriorReceita)}
					</TableCell>
				)}
				<TableCell align="right">
					{toCurrency(headerData?.totalizador?.metaMesMetaReceita)}
				</TableCell>
				<TableCell align="right">
					{toCurrency(headerData?.totalizador?.situacaoAtualReceita)}
				</TableCell>
				<TableCell
					style={{
						color:
							headerData?.totalizador?.percentualAtingidoReceita < 0
								? "red"
								: "blue",
					}}
					align="right"
				>
					{formatterPercent.format(
						headerData?.totalizador?.percentualAtingidoReceita / 100
					)}
				</TableCell>
				<TableCell align="right">
					{formatterPercent.format(
						headerData?.totalizador?.percentualPonderadoReceita / 100
					)}
				</TableCell>
			</TableRow>
			<TableRow
				className="linha-cinza"
				style={{ borderRight: "2px solid gray", borderLeft: "2px solid gray" }}
			>
				<TableCell align="left">Qtd. Qualificados</TableCell>
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.mes3QuantidadeQualificados}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.mes2QuantidadeQualificados}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.mes1QuantidadeQualificados}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.mediaTrimestreQuantidadeQualificados}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.mediaCrescimentoQuantidadeQualificados}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.metaMesAnteriorQuantidadeQualificados}
					</TableCell>
				)}
				<TableCell align="right">
					{headerData?.totalizador?.metaMesMetaQuantidadeQualificados}
				</TableCell>
				<TableCell align="right">
					{headerData?.totalizador?.situacaoAtualQuantidadeQualificados}
				</TableCell>
				<TableCell
					style={{
						color:
							headerData?.totalizador
								?.percentualAtingidoQuantidadeQualificados < 0
								? "red"
								: "blue",
					}}
					align="right"
				>
					{formatterPercent.format(
						headerData?.totalizador?.percentualAtingidoQuantidadeQualificados /
							100
					)}
				</TableCell>
				<TableCell align="right">
					{formatterPercent.format(
						headerData?.totalizador?.percentualPonderadoQuantidadeQualificados /
							100
					)}
				</TableCell>
			</TableRow>
			<TableRow
				className="linha-cinza"
				style={{ borderRight: "2px solid gray", borderLeft: "2px solid gray" }}
			>
				<TableCell align="left">Qtd. Não Qualificados</TableCell>
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.mes3QuantidadeNaoQualificados}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.mes2QuantidadeNaoQualificados}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.mes1QuantidadeNaoQualificados}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.mediaTrimestreQuantidadeNaoQualificados}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.mediaCrescimentoQuantidadeNaoQualificados}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.metaMesAnteriorQuantidadeNaoQualificados}
					</TableCell>
				)}
				<TableCell align="right">
					{headerData?.totalizador?.metaMesMetaQuantidadeNaoQualificados}
				</TableCell>
				<TableCell align="right">
					{headerData?.totalizador?.situacaoAtualQuantidadeNaoQualificados}
				</TableCell>
				<TableCell
					style={{
						color:
							headerData?.totalizador
								?.percentualAtingidoQuantidadeNaoQualificados < 0
								? "red"
								: "blue",
					}}
					align="right"
				>
					{formatterPercent.format(
						headerData?.totalizador?.percentualAtingidoQuantidadeNaoQualificados /
							100
					)}
				</TableCell>
				<TableCell align="right">
					{formatterPercent.format(
						headerData?.totalizador?.percentualPonderadoQuantidadeNaoQualificados /
							100
					)}
				</TableCell>
			</TableRow>
			<TableRow
				className="linha-cinza"
				style={{ border: "2px solid gray", borderTop: "0px solid white" }}
			>
				<TableCell align="left">Qtd. Operações</TableCell>
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.mes3QuantidadeOperacoes}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.mes2QuantidadeOperacoes}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.mes1QuantidadeOperacoes}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.mediaTrimestreQuantidadeOperacoes}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.mediaCrescimentoQuantidadeOperacoes}
					</TableCell>
				)}
				{!hideColumns && (
					<TableCell align="right">
						{headerData?.totalizador?.metaMesAnteriorQuantidadeOperacoes}
					</TableCell>
				)}
				<TableCell align="right">
					{headerData?.totalizador?.metaMesMetaQuantidadeOperacoes}
				</TableCell>
				<TableCell align="right">
					{headerData?.totalizador?.situacaoAtualQuantidadeOperacoes}
				</TableCell>
				<TableCell
					style={{
						color:
							headerData?.totalizador?.percentualAtingidoQuantidadeOperacoes < 0
								? "red"
								: "blue",
					}}
					align="right"
				>
					{formatterPercent.format(
						headerData?.totalizador?.percentualAtingidoQuantidadeOperacoes / 100
					)}
				</TableCell>
				<TableCell align="right">
					{formatterPercent.format(
						headerData?.totalizador?.percentualPonderadoQuantidadeOperacoes /
							100
					)}
				</TableCell>
			</TableRow>
		</>
	);

	return (
		<>
			<div style={{ margin: "0px 50px", textAlign: "end" }}></div>
			<div
				style={{
					margin: "20px 50px",
					zIndex: "0",
					position: "relative",
					overflowX: "auto",
				}}
			>
				<div
					className="report-tables"
					style={{
						display: headerData ? (hideColumns ? "flex" : "block") : "none",
						justifyContent: "center",
					}}
				>
					<Table
						style={{
							backgroundColor: "white",
							boxShadow:
								"0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
							maxWidth: hideColumns ? "1000px" : "2000px",
						}}
						striped
						hover
						condensed
					>
						<TableHead style={{ backgroundColor: "#232C63", color: "white" }}>
							<TableRow>
								<TableCell
									align="center"
									style={{ color: "white", fontWeight: "bold" }}
									rowSpan={2}
									colSpan={2}
								>
									META MENSAL
								</TableCell>
								{!hideColumns && (
									<TableCell
										align="center"
										style={{ color: "white", fontWeight: "bold" }}
										show="false"
										rowSpan={2}
									>
										{header.mes3Nome}
									</TableCell>
								)}
								{!hideColumns && (
									<TableCell
										align="center"
										style={{ color: "white", fontWeight: "bold" }}
										rowSpan={2}
									>
										{header.mes2Nome}
									</TableCell>
								)}
								{!hideColumns && (
									<TableCell
										align="center"
										style={{ color: "white", fontWeight: "bold" }}
										rowSpan={2}
									>
										{header.mes1Nome}
									</TableCell>
								)}
								{!hideColumns && (
									<TableCell
										align="center"
										style={{ color: "white", fontWeight: "bold" }}
										rowSpan={2}
									>
										Média Trimestral
									</TableCell>
								)}
								{!hideColumns && (
									<TableCell
										align="center"
										style={{ color: "white", fontWeight: "bold" }}
										rowSpan={1}
									>
										Média + Crescimento
									</TableCell>
								)}
								{!hideColumns && (
									<TableCell
										align="center"
										style={{ color: "white", fontWeight: "bold" }}
										rowSpan={2}
									>
										{"Meta " + header.mes1Nome ? header.mes1Nome : ""}
									</TableCell>
								)}
								<TableCell
									align="center"
									style={{ color: "white", fontWeight: "bold", width: "100px" }}
									rowSpan={2}
								>
									{"Meta " + header.mesMetaNome ? header.mesMetaNome : ""}
								</TableCell>
								<TableCell
									align="center"
									style={{ color: "white", fontWeight: "bold", width: "150px" }}
									rowSpan={1}
								>
									Situação Mês
								</TableCell>
								<TableCell
									align="center"
									style={{ color: "white", fontWeight: "bold", width: "100px" }}
									rowSpan={1}
								>
									% Atingido
								</TableCell>
								<TableCell
									align="center"
									style={{ color: "white", fontWeight: "bold", width: "100px" }}
									rowSpan={1}
								>
									% Atingido
								</TableCell>
								<TableCell
									align="center"
									style={{ color: "white", fontWeight: "bold", width: "100px" }}
									rowSpan={1}
								>
									% Atingido
								</TableCell>
							</TableRow>
							<TableRow>
								{!hideColumns && (
									<TableCell
										align="center"
										style={{
											color: "white",
											fontWeight: "bold",
											width: "100px",
										}}
									>
										{formatterPercent.format(header.mediaCrescimento / 100)}
									</TableCell>
								)}
								<TableCell
									align="center"
									style={{ color: "white", fontWeight: "bold" }}
								>
									{"Meta " + header.mesMetaNome ? header.mesMetaNome : ""}
								</TableCell>
								<TableCell
									align="center"
									style={{ color: "white", fontWeight: "bold", width: "100px" }}
								>
									Resultado
								</TableCell>
								<TableCell
									align="center"
									style={{ color: "white", fontWeight: "bold", width: "100px" }}
								>
									Ponderado
								</TableCell>
								<TableCell
									align="center"
									style={{ color: "white", fontWeight: "bold", width: "100px" }}
								>
									Total
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{bodyTable}
							{bodyTable ? totalTable : ""}
						</TableBody>
					</Table>
				</div>
			</div>
		</>
	);
}

export default TableContent;
